import { render, staticRenderFns } from "./ChoiceExerciseAnswer.vue?vue&type=template&id=58bf7562&scoped=true&"
import script from "./ChoiceExerciseAnswer.vue?vue&type=script&lang=js&"
export * from "./ChoiceExerciseAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceExerciseAnswer.vue?vue&type=style&index=0&id=58bf7562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf7562",
  null
  
)

export default component.exports